import { Component } from '@angular/core';

@Component({
  template: `<router-outlet></router-outlet>`,
})
export class DynReportsComponent { }



// WEBPACK FOOTER //
// ./src/app/dyn-reports/dyn-reports.component.ts